'use client'
import { formatDateToNice } from '@/modules/salary/common/utils'
import { useEffect, useState } from 'react'

// why do we have this?
// https://react.dev/reference/react-dom/client/hydrateRoot#handling-different-client-and-server-content
export function HistogramLastUpdatedDate({
  updatedAt,
}: {
  updatedAt: string | null
}) {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  return (
    <>
      Updated{' '}
      {isClient && updatedAt
        ? formatDateToNice({ date: new Date(updatedAt) })
        : null}
    </>
  )
}
